import styled, { css } from 'styled-components';
import theme from 'src/theme';
import { HeadingSmall } from '../../../styles/heading.style';
import { IButtonProps } from '../../../styles/button.style';
import { CommentsSectionInputElementWrapper } from '../../aol/comments-section/CommentsSection.style';

export const Header = styled.div`
    margin: 0.5rem 0 0 0;
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
    align-items: center;
    background-color: ${theme.legacyColors.headingPanelBgColor};
`;

export const HeaderSection = styled.div`
    display: flex;
    align-items: center;
`;

export const HeaderItem = styled.div`
    padding: 8px 4px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .highlight {
        font-weight: 700;
        text-transform: uppercase;
    }
`;

type TableWrapperProps = {
    hasNewCargo: boolean;
};

export const TableWrapper = styled.div<TableWrapperProps>`
    overflow: auto;
    height: calc(100% - ${(props) => (props.hasNewCargo ? '100px' : '10px')});
`;

export const CargoTemperatureOpenHeader = styled.h5`
    padding: 1rem 0;
`;

export const CargoTemperatureControlWrapper = styled.div``;

export const CargoTemperatureRow = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
`;

export const CargoTankWrapper = styled.div`
    display: flex;
    float: left;
    min-width: 100%;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.border.input};
    padding: 0px 3px;
    &.alt-bg {
        background: ${(props) => props.theme.colors.background.altRow};
    }
`;

export const CargoTankList = styled.div`
    margin: 0.5rem 0;
`;

export const ColHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const CargoCol = styled.div`
    font-size: 0.8rem;
    text-align: left;
    font-size: 0.8rem;
    display: flex;
    flex-direction: row;
    margin-right: 5px;
    &.header {
        font-weight: 500;
    }
    &.cargo-nr {
        width: 6rem;
    }
    &.trade-name {
        width: 16rem;
    }
    &.tank-name {
        width: 5rem;
    }
    &.category {
        width: 8rem;
    }
    &.unit {
        width: 3rem;
        text-align: center;
    }
`;

export const CargoHeaderRowGroupsWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
`;

type LogFieldsColumnProps = {
    showComments: boolean;
};

export const CargoHeaderRowGroup = styled.div<LogFieldsColumnProps>`
    text-align: center;
    ${(props) => (props.showComments ? 'width: 18rem;' : 'width: 14rem;')}
    .log-time {
        color: ${(props) => props.theme.colors.text.panelHeading};
        background: ${(props) => props.theme.colors.background.logTime};
        border-radius: 4px;
        padding: 2px 3px 0;
        display: inline-block;
        font-size: 0.7rem;
    }
`;

export const CargoHeaderFieldsWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const CargoHeaderField = styled.div`
    padding: 0 6px;
    &.unit-col {
        width: 95px;
    }
`;

type CargoTankRowProps = {
    numberOfFields: number;
};

export const CargoTankHeaderRow = styled(HeadingSmall)<CargoTankRowProps>`
    align-items: center;
    width: fit-content;
    min-width: 100%;
    ${() => cargoTankRowCss()}
`;

export const CargoTankRow = styled.div<CargoTankRowProps>`
    ${() => cargoTankRowCss()}

    label {
        .input-value-wrapper {
            justify-content: flex-start;
            margin-left: 0.5rem;
        }
    }
`;

export const CargoTankFieldsRow = styled(CargoTankRow)<CargoTankRowProps>`
    display: flex;
    justify-content: flex-start;
`;
const cargoTankRowCss = () => `
    display: flex;
    justify-content: flex-start;
`;

export const CargoInputWrapper = styled.div`
    border-left: 0.1rem solid;
`;

export const CargoFieldGroup = styled.div<LogFieldsColumnProps>`
    display: flex;
    justify-content: flex-start;
    ${(props) => (props.showComments ? 'width: 18rem;' : 'width: 14rem;')}
    padding: 3px 5px  3px 0;
    flex: 1;
    label {
        padding: 0;
    }
    label input[type='text'] {
        width: 45px;
    }
`;

export const CargoInputField = styled.div`
    label {
        padding: 0px 1px;
    }
    width: 30%;
    &.unit-col {
        width: 95px;
        .number {
            width: 70px;
        }
    }
`;

export const OnBoardWrapper = styled.div`
    width: 35px;
`;

export const CargoCommentField = styled.div`
    padding: 0px 26px;
`;

export const SortButton = styled.button<IButtonProps>`
    font-size: 0.8rem;
    color: ${(props) => props.theme.colors.text.portName};
    border: 0;
    cursor: pointer;
    padding: 1px 6px;
    margin: 6px;
    border: 1px solid transparent;
    background: ${theme.legacyColors.headingPanelBgColor};

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: ${theme.legacyColors.atSea};
            border: 1px solid #${theme.legacyColors.selectedBorder};
            color: ${theme.legacyColors.selectedColor};
        `}
`;

export const CommentWrapper = styled(CommentsSectionInputElementWrapper)`
    width: 92%;
    margin: -2px 0px;
    textarea {
        width: 100%;
    }
`;
